import { render, staticRenderFns } from "./projectPbrIndex.vue?vue&type=template&id=500387b8&"
import script from "./projectPbrIndex.vue?vue&type=script&lang=js&"
export * from "./projectPbrIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports